/**
 * Admin 사용자 관리. 라우트 admin.php users 그룹과 동기화.
 * edit: 프로필 이미지 선택 시 미리보기 갱신.
 * 영구삭제 버튼: admin/global/AdminUserDestroy.ts 에서 이벤트 위임으로 처리 (Modal.confirm 활용).
 */
import { Logger } from "../../utils/Logger";
import { AdminIndexTable } from "../components/AdminIndexTable";

function noop(controller: string, action: string): void {
    Logger.debug(`${controller}.${action} (no-op)`);
}

function edit(): void {
    const wrap = document.querySelector("[data-user-avatar-upload]");
    if (!wrap) return;
    const input = wrap.querySelector<HTMLInputElement>("[data-avatar-input]");
    const preview = wrap.querySelector("[data-avatar-preview]");
    if (!input || !preview) return;

    let previousBlobUrl: string | null = null;
    input.addEventListener("change", () => {
        const file = input.files?.[0];
        if (!file || !file.type.startsWith("image/")) {
            if (!file) {
                const initial = preview.querySelector("[data-avatar-initial]");
                const img = preview.querySelector("img");
                if (img) img.remove();
                if (initial) (initial as HTMLElement).style.display = "";
            }
            return;
        }
        if (previousBlobUrl) URL.revokeObjectURL(previousBlobUrl);
        const url = URL.createObjectURL(file);
        previousBlobUrl = url;
        const img = preview.querySelector("img");
        const initial = preview.querySelector("[data-avatar-initial]");
        if (img) {
            img.src = url;
            (img as HTMLImageElement).style.display = "";
        } else {
            const newImg = document.createElement("img");
            newImg.src = url;
            newImg.alt = "";
            newImg.width = 80;
            newImg.height = 80;
            newImg.className = "admin-form__avatar-img";
            preview.innerHTML = "";
            preview.appendChild(newImg);
        }
        if (initial) (initial as HTMLElement).style.display = "none";
    });
}


export const UserController = {
    index(): void {
        Logger.debug("UserController.index");
        // 영구삭제: initAdminUserDestroyButtons() (admin 공통)에서 이벤트 위임 처리
        new AdminIndexTable().init();
    },
    create(): void {
        noop("UserController", "create");
    },
    store(): void {
        noop("UserController", "store");
    },
    edit(): void {
        edit();
    },
    update(): void {
        noop("UserController", "update");
    },
    showPasswordChangeForm(): void {
        noop("UserController", "showPasswordChangeForm");
    },
    changePassword(): void {
        noop("UserController", "changePassword");
    },
    showForgotPasswordForm(): void {
        noop("UserController", "showForgotPasswordForm");
    },
    forgotPassword(): void {
        noop("UserController", "forgotPassword");
    },
    resetPassword(): void {
        noop("UserController", "resetPassword");
    },
};
